<div class="related-container">
  <div class="custom-mat-spinner" *ngIf="isSpinnerShown">
    <mat-spinner></mat-spinner>
    <div class="text">Data loading...</div>
  </div>

  <div *ngIf="!isSpinnerShown">
    <!-- Company -->
    <section class="block">
      <div class="block-title">
        <span (click)="isCompanyExpanded = !isCompanyExpanded">Company</span>
        <span class="shevron" (click)="isCompanyExpanded = !isCompanyExpanded">
          <img [ngClass]="isCompanyExpanded ? 'img-up' : ''" src="../../../../assets/img/invoiceForm/shevron.svg"
            alt="">
        </span>
      </div>
      <div class="block-content" *ngIf="!supplierId" [ngClass]="isCompanyExpanded ? 'block-expanded padding-top' : ''">
        <span class="no-company">No company selected</span>
      </div>
      <div class="block-content" *ngIf="relatedData?.company?.name"
        [ngClass]="isCompanyExpanded ? 'block-expanded' : ''">
        <div class="type-1 hover-gray" style="cursor: pointer;" *ngIf="isCompanyExpanded" (click)="showContactPanel()"
          matTooltip="Click to see supplier details" [matTooltipShowDelay]="showToolTipDelay">
          <div class="logo-container">
            <app-supplier-avatar class="logo {{hexColorClass}}"
              [supplierId]="relatedData?.company?.id || supplierId" [supplierName]="relatedData?.company?.name">
              <span>{{relatedData?.company?.name | shortLogo}}</span>
            </app-supplier-avatar>
          </div>
          <div class="desc">
            <div class="title">{{relatedData?.company?.name}}</div>
            <div class="subtitle"
              *ngIf="relatedData?.company?.firstName || relatedData?.company?.lastName || relatedData?.company?.email">
              <span
                *ngIf="relatedData?.company?.firstName || relatedData?.company?.lastName">{{relatedData.company.firstName}}&nbsp;{{relatedData.company.lastName}}</span>
              <span *ngIf="relatedData?.company?.email">&nbsp;-&nbsp;{{relatedData.company.email}}</span>
            </div>
          </div>
        </div>

        <!-- Bills Section (Moved here) - temporarily hidden, re-enable to restore -->
        <!--
        <div class="bills-section" *ngIf="relatedData?.invoices?.length > 0">
          <div class="bills-header">
            <div class="status-filters">
              <button *ngFor="let status of statusFilters" class="status-pill"
                [class.active]="activeStatusFilter === status" (click)="filterBillsByStatus(status)">
                {{status}} ({{getStatusCount(status)}})
              </button>
            </div>
            <div class="filter-total" *ngIf="filteredTotal > 0">
              Total: {{filteredTotal | customCurrency}}
            </div>
          </div>

          <div class="bills-content" *ngIf="isBillsExpanded">
            Bills List
            <div class="bills-list">
              <div *ngIf="filteredOutstandingInvoices?.length > 0">
                <div *ngFor="let invoice of filteredOutstandingInvoices" class="bill-item"
                  (click)="showInvoice(invoice)">
                  <div class="bill-main">
                    <div class="bill-header">
                      <div class="bill-info">
                        <div class="reference-container">
                          <span class="reference">#{{invoice.invoiceNumber}}</span>
                          <span class="status" [ngClass]="invoice.status | lowercase">{{invoice.status}}</span>
                        </div>
                        <span class="amount">{{invoice.amountDue | customCurrency}}</span>
                      </div>
                    </div>
                    <div class="bill-dates">
                      <span class="date">{{invoice.date | date:'mediumDate'}}</span>
                      <span class="due" *ngIf="invoice.dueDate">Due {{invoice.dueDate | date:'mediumDate'}}</span>
                      <span class="payment-date" *ngIf="invoice.paymentDate">Paid {{invoice.paymentDate |
                        date:'mediumDate'}}</span>
                    </div>
                  </div>
                  <i class="fas fa-chevron-right arrow"></i>
                </div>
              </div>
              Add no records message
              <div *ngIf="!filteredOutstandingInvoices?.length" class="no-records">
                <i class="far fa-folder-open"></i>
                <span>No expenses found for this filter</span>
              </div>
            </div>
          </div>
        </div>
        -->
      </div>
    </section>

    <!-- Approvals: whether this bill is approved, and who has been asked. The approver decides in
         the approval block at the foot of the bill's form, where Publish sits. -->
    <section class="block">
      <div class="block-title">
        <span (click)="isApprovalsExpanded = !isApprovalsExpanded">Approvals</span>
        <span class="shevron" (click)="isApprovalsExpanded = !isApprovalsExpanded">
          <img [ngClass]="isApprovalsExpanded ? 'img-up' : ''" src="../../../../assets/img/invoiceForm/shevron.svg"
            alt="">
        </span>
        <span class="plus" matTooltip="Request approval" [matTooltipShowDelay]="showToolTipDelay"
          role="button" tabindex="0" aria-label="Request approval"
          (click)="requestApproval()" (keydown.enter)="requestApproval()">
          <img src="../../../../assets/img/invoiceForm/plus.svg" alt="">
        </span>
      </div>
      <div class="block-content" [ngClass]="isApprovalsExpanded ? 'block-expanded' : ''">
        <div class="rel-list" *ngIf="isApprovalsExpanded">

          <!-- Approved -->
          <div class="rel-row" *ngIf="approval as a">
            <span class="rel-avatar rel-avatar--done" aria-hidden="true">
              <svg viewBox="0 0 16 16" fill="none"><path d="M3.5 8.5l3 3 6-7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" /></svg>
            </span>
            <span class="rel-row__text">
              <span class="rel-row__title">Approved<ng-container *ngIf="a.name"> by {{ a.name }}</ng-container></span>
              <span class="rel-row__sub" *ngIf="a.at">{{ a.at | formatedDate }}</span>
            </span>
            <span class="m-pill m-pill--success m-pill--dot">Approved</span>
          </div>

          <!-- Asked, and the latest decisions. -->
          <div class="rel-row" *ngFor="let t of recordTasks; trackBy: trackTask">
            <span class="rel-avatar" [class.rel-avatar--quiet]="t.status !== 'open'" aria-hidden="true">
              {{ t.assignedToRole ? '★' : (t.assignedToName | shortLogo) }}
            </span>
            <span class="rel-row__text">
              <span class="rel-row__title">{{ assigneeLabel(t) }}</span>
              <span class="rel-row__sub">{{ requestLine(t) }}</span>
            </span>
            <span class="m-pill" [ngClass]="taskPillClass(t)">{{ taskPillLabel(t) }}</span>
          </div>

          <!-- Sent before requests were tasks, and never mirrored onto one. -->
          <div class="rel-row" *ngIf="showsLegacyPending">
            <span class="rel-avatar" aria-hidden="true">{{ approvals.approvedBy?.name | shortLogo }}</span>
            <span class="rel-row__text">
              <span class="rel-row__title">{{ approvals.approvedBy?.name || 'Approver' }}</span>
              <span class="rel-row__sub">Asked to approve<ng-container *ngIf="approvals.approvedAt"> · {{ approvals.approvedAt | formatedDate }}</ng-container></span>
            </span>
            <span class="m-pill m-pill--warning m-pill--dot">Pending</span>
          </div>

          <!-- Not approved and nobody asked yet. -->
          <div class="rel-empty" *ngIf="!approval && !hasOpenRequest && !showsLegacyPending">
            <p class="rel-empty__text" *ngIf="!recordTasks.length">
              {{ recordTasksLoaded ? 'Not approved yet.' : 'Loading…' }}
            </p>
            <div class="rel-empty__actions">
              <button type="button" class="sd-btn sd-btn--primary sd-btn--sm" (click)="requestApproval()">
                Request approval
              </button>
              <button type="button" class="rel-link" [disabled]="isApproving" (click)="approveInvoice()">
                {{ isApproving ? 'Approving…' : 'Approve it yourself' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Transactions -->
    <section class="block">
      <div class="block-title">
        <span (click)="isTransactionsExpanded = !isTransactionsExpanded">Transactions</span>
        <span class="shevron" (click)="isTransactionsExpanded = !isTransactionsExpanded">
          <img [ngClass]="isTransactionsExpanded ? 'img-up' : ''" src="../../../../assets/img/invoiceForm/shevron.svg"
            alt="">
        </span>
      </div>
      <div class="block-content" *ngIf="transactions?.length > 0"
        [ngClass]="isTransactionsExpanded ? 'block-expanded' : ''">
        <div class="transactions-container" *ngIf="isTransactionsExpanded">
          <div *ngFor="let transaction of transactions" class="transaction-item hover-gray clickable"
            (click)="navigateToTransaction(transaction)" matTooltip="Click to view transaction details"
            [matTooltipShowDelay]="showToolTipDelay">
            <div class="transaction-main">
              <div class="transaction-header">
                <div class="transaction-info">
                  <span class="transaction-date">{{transaction.date | date:'mediumDate'}}</span>
                  <span class="transaction-amount" [ngClass]="transaction.amount < 0 ? 'negative' : 'positive'">
                    {{transaction.amount | customCurrency}}
                  </span>
                </div>
              </div>
              <div class="transaction-details">
                <div class="statement-text">{{transaction.statementText}}</div>
                <div class="report-pill-container">
                  <span class="report-pill">{{transaction.reportName}}</span>
                </div>
              </div>
            </div>
            <div class="arrow">></div>
          </div>
        </div>
      </div>
      <div class="block-content" *ngIf="!transactions?.length"
        [ngClass]="isTransactionsExpanded ? 'block-expanded padding-top' : ''">
        <span class="no-company">No transactions found</span>
      </div>
    </section>

    <!-- Accounting -->
    <section class="block"
      *ngIf="supplierId && !relatedData?.organization?.isNoAccounting && (relatedData?.invoice?.processed || this.billsToPayMode)">
      <div class="block-title">
        <span (click)="isAccountingExpanded = !isAccountingExpanded">
          <span *ngIf="!relatedData?.organization?.isQBO">Xero</span>
          <span *ngIf="relatedData?.organization?.isQBO">QuickBooks</span>
        </span>
        <span class="shevron" (click)="isAccountingExpanded = !isAccountingExpanded">
          <img [ngClass]="isAccountingExpanded ? 'img-up' : ''" src="../../../../assets/img/invoiceForm/shevron.svg"
            alt="">
        </span>
      </div>
      <div class="block-content" *ngIf="relatedData?.company?.name"
        [ngClass]="isAccountingExpanded ? 'block-expanded' : ''">
        <div class="type-3" *ngIf="isAccountingExpanded">
          <div class="logo-container">
            <div class="accounting-logo">
              <img *ngIf="!relatedData?.organization?.isQBO" class="act-logo"
                src="../../../../assets/img/company/XeroLogo.svg" alt="" />
              <img *ngIf="relatedData?.organization?.isQBO" class="act-logo"
                src="../../../../assets/img/company/QBOLogo.png" alt="" />
            </div>
          </div>
          <div class="desc">
            <div class="title">{{relatedData?.company?.name}}</div>
            <div class="subtitle">
              <span>{{invoice?.invoiceNumber}}</span>
              <span *ngIf="invoice?.invoiceNumber">&nbsp;-&nbsp;</span>
              <span>{{relatedData?.invoice?.status}}</span>
            </div>
          </div>
          <a class="img-goto" *ngIf="link" href="{{link}}" target="_blank"
            [matTooltip]="relatedData?.organization?.isQBO ? 'Go to QuickBooks' : 'Go to Xero'"
            [matTooltipShowDelay]="showToolTipDelay">
            <img src="../../../../assets/img/invoiceForm/goto.svg" alt="" />
          </a>
        </div>
        <div *ngIf="!relatedData?.organization?.isQBO && relatedData?.invoice?.accIntInvoiceId" class="xero-history-link-row">
          <a (click)="loadXeroHistory()" class="xero-history-link">
            {{ isXeroHistoryShown ? 'Hide Xero History' : 'See Xero History' }}
          </a>
        </div>
        <div *ngIf="isXeroHistoryShown && !relatedData?.organization?.isQBO" class="xero-history-panel">
          <div *ngIf="isXeroHistoryLoading" class="xero-history-loading">Loading...</div>
          <div *ngIf="!isXeroHistoryLoading && xeroHistory.length == 0" class="xero-history-empty">No Xero history found.</div>
          <div *ngFor="let item of xeroHistory" class="xero-history-item">
            <div class="xero-history-item-changes">{{ item.changes }}</div>
            <div class="xero-history-item-meta">{{ item.user }} &middot; {{ item.dateUTC | date:'dd MMM yyyy, h:mm a' }}</div>
            <div *ngIf="item.details" class="xero-history-item-details">{{ item.details }}</div>
          </div>
        </div>
      </div>
    </section>

    <!-- Tags -->
    <section class="block">
      <div class="block-title">
        <span (click)="isTagsExpanded = !isTagsExpanded">Tags</span>
        <span class="shevron" (click)="isTagsExpanded = !isTagsExpanded"></span>
        <img [ngClass]="isTagsExpanded ? 'img-up' : ''" src="../../../../assets/img/invoiceForm/shevron.svg" alt="">
        <span class="plus" matTooltip="Click to add a tag to the invoice" [matTooltipShowDelay]="showToolTipDelay"
          mat-button [matMenuTriggerFor]="menu">
          <img src="../../../../assets/img/invoiceForm/plus.svg" alt="">
        </span>
        <mat-menu #menu="matMenu" class="inbox-menu" (closed)="menuClosed()">
          <!-- Add a tag menu items -->
          <div class="add-tag-list">
            <div class="search-tag">
              <input class="search-input" type="text" placeholder="Search Tag" (click)="$event.stopPropagation()"
                [ngModel]="tagSearchTerm" (ngModelChange)="filterTags($event)" (blur)="clearTagSearchValue()">
            </div>
            <div class="add-tag">
              <div class="tag-list-item tag-pill-list" *ngFor="let tagMenuItem of filteredTagList"
                (click)="addTagToInvoices(tagMenuItem)">
                <span class="tag-pill" [ngClass]="'tag-pill--' + pillSize" role="listitem" [style.backgroundColor]="tagMenuItem.backColor">
                  <span class="tag-pill__label" [style.color]="tagMenuItem.textColor">
                    {{ tagMenuItem.tagName }}
                  </span>
                </span>  
              </div>
              <!-- If now filtered tags -->
              <div class="tag-list-item" *ngIf="isAddTagMenuItemShown" (click)="createNewTag()">
                + New Tag ‘{{this.tagSearchTerm}}’
              </div>
            </div>
          </div>
        </mat-menu>
      </div>
      <div class="block-content" *ngIf="relatedData.invoice.tags?.length > 0"
        [ngClass]="isTagsExpanded ? 'block-expanded' : ''">
        <div class="tags-container">
          <!-- <span class="tag" *ngFor="let tag of relatedData.invoice?.tags" [ngStyle]="{'color': tag.textColor, 'background': tag.backColor}">
        <span>{{tag.tagName}}</span>
        <span class="del-icon" (click)="deleteTagFromInvoice(tag)"
          matTooltip="Delete from the invoice" [matTooltipShowDelay]="showToolTipDelay">
          <i class="fas fa-close" [ngStyle]="{'color': tag.textColor}"></i>
        </span>
        </span> -->
          <app-tag-pill [tags]="relatedData.invoice?.tags" [showPlaceholderWhenEmpty]="false"
            (pillCleared)="deleteTagFromInvoice($event)"></app-tag-pill>
        </div>
      </div>
      <div class="block-content" *ngIf="relatedData.invoice.tags?.length == 0"
        [ngClass]="isTagsExpanded ? 'block-expanded padding-top' : ''">
        <span class="no-company">No tags</span>
      </div>
    </section>

    <!-- Forms -->
    <section class="block" *ngIf="completedTasks?.length > 0">
      <div class="block-title">
        <span (click)="isFormsExpanded = !isFormsExpanded">Forms</span>
        <span class="shevron" (click)="isFormsExpanded = !isFormsExpanded">
          <img [ngClass]="isFormsExpanded ? 'img-up' : ''" src="../../../../assets/img/invoiceForm/shevron.svg" alt="">
        </span>
      </div>
      <div class="block-content" *ngIf="completedTasks?.length > 0" [ngClass]="isFormsExpanded ? 'block-expanded' : ''">
        <div class="forms-container" *ngFor="let form of completedTasks">
          <span class="form" (click)="openTaskDetailDialog(form)">
            <span>{{form.name}}</span>
          </span>
        </div>
      </div>
    </section>

    <!-- Visibility -->
    <section class="block">
      <div class="block-title">
        <span (click)="isVisibilityExpanded = !isVisibilityExpanded">Visibility</span>
        <span class="shevron" (click)="isVisibilityExpanded = !isVisibilityExpanded">
          <img [ngClass]="isVisibilityExpanded ? 'img-up' : ''" src="../../../../assets/img/invoiceForm/shevron.svg"
            alt="">
        </span>
      </div>
      <div class="block-content" [ngClass]="isVisibilityExpanded ? 'block-expanded' : ''">
        <div class="visibility-pills">
          <!-- Admin pill (non-removable) -->
          <span class="pill admin">Admin</span>
          <!-- Placeholder user pills -->
          <span class="pill user" *ngFor="let user of visibilityUsers; let i = index"
            (mouseenter)="hoveredUserIndex = i" (mouseleave)="hoveredUserIndex = -1">
            {{user.name}}
            <span class="pill-x" *ngIf="hoveredUserIndex === i" (click)="removeVisibilityUser(i, $event)">×</span>
          </span>
          <!-- Add user pill -->
          <span class="pill add-user" (click)="openUserList()">+</span>
        </div>
        <!-- User list dropdown -->
        <div class="user-list-dropdown" *ngIf="isUserListOpen">
          <div class="user-list-search">
            <input type="text" [(ngModel)]="userSearchTerm" (ngModelChange)="filterUserList($event)"
              placeholder="Search user..." />
          </div>
          <div class="user-list-item" *ngFor="let user of filteredOrgUsers" (click)="addVisibilityUser(user)">
            {{user.name}}
          </div>
        </div>
      </div>
    </section>
  </div>
</div>